export namespace LearningStatus {
  export enum Values {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE',
    ARCHIVED = 'ARCHIVED',
    DELETED = 'DELETED'
  }

  export function label(status: Values) {
    switch (status) {
      case Values.DRAFT:
        return 'Brouillon'
      case Values.ACTIVE:
        return 'Actif'
      case Values.ARCHIVED:
        return 'Archivé'
      case Values.DELETED:
        return 'Supprimé'
    }
  }

  export function color(status: Values) {
    switch (status) {
      case Values.DRAFT:
        return 'secondary'
      case Values.ACTIVE:
        return 'success'
      case Values.ARCHIVED:
        return 'danger'
      case Values.DELETED:
        return 'danger'
    }
  }
}
